import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';

interface GravityCompassProps {
    gravityVector: { x: number; y: number };
    debugInfo?: string; // 保留接口定义但不使用，或者也可以删除
}

export const GravityCompass: React.FC<GravityCompassProps> = ({ gravityVector }) => {
    const isMobile = useIsMobile();

    if (!isMobile) return null;

    return (
        <div className="relative pointer-events-none z-10 opacity-90 flex flex-col items-center gap-1 shrink-0">
            <div className="relative w-14 h-14 flex items-center justify-center rounded-full border border-white/30 bg-black/10 shadow-sm">
                {/* 十字准星 */}
                <div className="absolute w-full h-px bg-white/20 top-1/2 -translate-y-1/2"></div>
                <div className="absolute h-full w-px bg-white/20 left-1/2 -translate-x-1/2"></div>
                
                {/* 重力指针 */}
                <div 
                    className="w-1 bg-gradient-to-b from-red-500 to-transparent origin-top absolute top-1/2 left-1/2 -translate-x-1/2 rounded-full"
                    style={{ 
                        transform: `rotate(${Math.atan2(gravityVector.y, gravityVector.x) * 180 / Math.PI - 90}deg)`,
                        height: `${Math.min(20, Math.sqrt(gravityVector.x**2 + gravityVector.y**2) * 10 + 8)}px`,
                        opacity: Math.min(1, Math.sqrt(gravityVector.x**2 + gravityVector.y**2) + 0.3)
                    }}
                ></div>
                
                {/* 中心点 */}
                <div className="w-1 h-1 bg-white/80 rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-sm z-10" />
            </div>
        </div>
    );
};
